import { TextObjectType } from './TextObjectType';
export var isTextObject = function (block) {
    return Object.values(TextObjectType).includes(block.type);
};
//# sourceMappingURL=isTextObject.js.map